module.exports = __webpack_public_path__ + "img/740533697c50463d2ddb9a4856a0a15f.506dad98.png";